"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_redux_1 = require("react-redux");
const slice_1 = require("../../../app-reduxs/login/slice");
const Colors_1 = __importDefault(require("../../../assets/colors/Colors"));
const BackHeader_1 = __importDefault(require("../../../assets/icons/BackHeader"));
const components_1 = require("../../../components");
const CustomText_1 = __importDefault(require("../../../components/text/CustomText"));
const enums_1 = require("../../../constants/enums");
const User_1 = __importDefault(require("../../../networking/apis/User"));
const DisconnectScreen_1 = require("../../DisconnectScreen");
const styles_1 = __importDefault(require("./styles"));
const ArticleNotifySettingScreen = (props) => {
    const { type } = props.route?.params;
    const dataUser = (0, react_redux_1.useSelector)(slice_1.selectProfile);
    const connected = (0, react_redux_1.useSelector)((state) => state.appReducer.connected);
    const dispatch = (0, react_redux_1.useDispatch)();
    const [dataNoti, setDataNoti] = (0, react_1.useState)({
        article_liked: enums_1.Status.Inactive,
        article_commented: enums_1.Status.Inactive,
        article_inherited: enums_1.Status.Inactive,
        article_posted: enums_1.Status.Inactive,
    });
    (0, react_1.useEffect)(() => {
        if (dataUser) {
            const { article_liked, article_commented, article_inherited, article_posted } = type == enums_1.NotiType.PUSH_NOTI
                ? dataUser.push_notification_setting
                : dataUser.box_notification_setting;
            setDataNoti({
                article_liked,
                article_commented,
                article_inherited,
                article_posted,
            });
        }
    }, [dataUser]);
    const handleChangeSetting = async (formData) => {
        if (!dataUser)
            return;
        try {
            if (type == enums_1.NotiType.PUSH_NOTI) {
                const settingChangeData = await User_1.default.pushNotiSetting(formData);
                const newUser = {
                    ...dataUser,
                    push_notification_setting: {
                        ...dataUser.push_notification_setting,
                        ...settingChangeData.data,
                    },
                };
                dispatch((0, slice_1.setProfileAction)(newUser));
            }
            else {
                const settingChangeData = await User_1.default.boxNotiSetting(formData);
                const newUser = {
                    ...dataUser,
                    box_notification_setting: {
                        ...dataUser.box_notification_setting,
                        ...settingChangeData.data,
                    },
                };
                dispatch((0, slice_1.setProfileAction)(newUser));
            }
        }
        catch (err) {
            console.log(err);
        }
    };
    if (!connected)
        return react_1.default.createElement(DisconnectScreen_1.DisconnectScreen, null);
    return (react_1.default.createElement(react_native_1.View, { style: styles_1.default.container },
        react_1.default.createElement(components_1.Header, { statusBarStyle: "dark-content", styleViewCenter: { alignItems: 'center' }, titleStyle: {
                alignSelf: 'center',
            }, title: type == enums_1.NotiType.PUSH_NOTI ? "プッシュ通知" : "アプリ内通知欄", styleContainer: {
                backgroundColor: Colors_1.default.white,
            }, leftIcon: react_1.default.createElement(BackHeader_1.default, null) }),
        react_1.default.createElement(react_native_1.ScrollView, { contentContainerStyle: styles_1.default.body, showsVerticalScrollIndicator: false },
            react_1.default.createElement(react_native_1.View, { style: styles_1.default.titleView },
                react_1.default.createElement(CustomText_1.default, { weight: "600", style: styles_1.default.title }, "\u8A18\u4E8B")),
            react_1.default.createElement(components_1.SwitchView, { defaultValue: dataNoti?.article_liked == 1, title: "\u3044\u3044\u306D\u901A\u77E5", description: "\u3042\u306A\u305F\u306E\u6295\u7A3F\u3084\u30B3\u30E1\u30F3\u30C8\u306B\u5BFE\u3057\u3066\u3044\u3044\u306D\u3055\u308C\u305F\u969B\u306B\u304A\u77E5\u3089\u305B\u3057\u307E\u3059\u3002", onChangeValue: (value) => {
                    handleChangeSetting({ article_liked: value });
                } }),
            react_1.default.createElement(components_1.SwitchView, { defaultValue: dataNoti?.article_commented == 1, title: "\u30B3\u30E1\u30F3\u30C8\u901A\u77E5", description: "\u3042\u306A\u305F\u306E\u6295\u7A3F\u3084\u30B3\u30E1\u30F3\u30C8\u306B\u5BFE\u3057\u3066\u30B3\u30E1\u30F3\u30C8\u3055\u308C\u305F\u969B\u306B\u304A\u77E5\u3089\u305B\u3057\u307E\u3059\u3002", onChangeValue: (value) => {
                    handleChangeSetting({ article_commented: value });
                } }),
            react_1.default.createElement(components_1.SwitchView, { defaultValue: dataNoti?.article_inherited == 1, title: "\u7D99\u627F\u901A\u77E5", description: "\u3042\u306A\u305F\u306E\u8A18\u4E8B\u304C\u7D99\u627F\u3055\u308C\u305F\u969B\u306B\u304A\u77E5\u3089\u305B\u3057\u307E\u3059\u3002", onChangeValue: (value) => {
                    handleChangeSetting({ article_inherited: value });
                } }),
            react_1.default.createElement(components_1.SwitchView, { defaultValue: dataNoti?.article_posted == 1, title: "\u6295\u7A3F\u901A\u77E5", description: "\u30D5\u30A9\u30ED\u30FC\u3057\u3066\u3044\u308B\u30E6\u30FC\u30B6\u30FC\u304C\u6295\u7A3F\u3057\u305F\u969B\u306B\u304A\u77E5\u3089\u305B\u3057\u307E\u3059\u3002", onChangeValue: (value) => {
                    handleChangeSetting({ article_posted: value });
                } }))));
};
exports.default = ArticleNotifySettingScreen;
